module.exports = __webpack_public_path__ + "img/voice.a8cf0bd3.png";